<template>
  <div class="main-content">
    <div class="content">
      <el-form ref="form" :model="form" label-width="84px">
        <el-row>
          <el-col :span="6" :offset="11">
            <el-form-item label="项目名称/编号：" label-width="120px" props="projectCode" style="margin-bottom: 10px">
              <el-input v-model="form.code" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="预警内容：" label-width="80px" props="projectName">
              <el-input v-model="form.name" style="width:100%" clearable placeholder="请输入内容搜索"
                @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="" label-width="12px">
              <div>
                <el-button size="small" type="primary">搜索</el-button>
                <el-button plain size="small" type="primary">重置</el-button>
                <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true">|
                  展开</el-button>
                <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false">|
                  收起</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="warn-color" style="margin: 0 0 16px 0">
        <div class="warn-flex">
          <div class="flex-left">
            <span v-for="(item, index) in count" :key="index" style="color: rgba(0, 0, 0, 0.45);">
              <b>{{ item.count }}</b>
              <span style="padding-right:10px;color:#000;font-weight:bold">条</span>
              {{ item.gradeName }}
            </span>
          </div>
          <div class="flex-right">
            <span>
              <b>273</b>
            </span>
          </div>
        </div>
        <div class="color-list">
          <div class="color">
            <span v-for="(item, index) in count" :key="index"
              :style="{ width: ((item.count) / 273 * 100) + '%', background: 'red' }"></span>
          </div>
          <span>待处理条数</span>
        </div>
      </div>

      <el-table :data="tableData" stripe border>
        <el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="预警处理状态" prop="status" align="center" min-width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :class="['mlink', 'warning']">
              <span :class="['dot', 'warning']"></span> 待处理
            </span>
          </template>
        </el-table-column>

        <el-table-column label="预警等级" prop="level" align="center" min-width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div
              style="background-color: rgb(247,131,131); color: #FFF; display: inline-block; border-radius: 4px; padding: 2px 8px;">
              红色预警</div>
          </template>
        </el-table-column>

        <el-table-column label="项目（标段）名称" prop="projectName" align="left" min-width="300"
          :show-overflow-tooltip="true"></el-table-column>

        <el-table-column label="预警项" prop="item" align="left" min-width="120" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="预警内容" prop="content" align="left" min-width="250"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="预警触发值" prop="value" align="left" min-width="150"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="实际值" prop="realValue" align="center" min-width="120"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="预警时间" prop="time" align="left" min-width="200"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="预警接收手机" prop="phone" align="left" min-width="150"
          :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      count: [],
      moreSearchItem: false,
      form: {
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
    };
  },
  mounted() {
    this.count = [
      { gradeName: '红色预警', count: 273 },
      { gradeName: '橙色预警', count: 0 },
      { gradeName: '黄色预警', count: 0 },
    ];
    this.tableData = window.__tableData__;
  },
  methods: {
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
  },
}
</script>
<style lang="less" scoped>
.warn-color {
  height: 96px;
  background: #f5f7fb;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.45);
  padding: 0px 26px 0px 16px;

  .warn-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px 0px 14px 0px;

    b {
      font-size: 18px;
      color: #000;
    }

    span {
      // padding-right: 30px;
    }

    .flex-left {
      width: 95%;
    }

    .flex-right {
      min-width: 70px;
      text-align: center;
    }
  }

  .color-list {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .color {
      width: 95%;
      height: 16px;
      // border-left: 500px solid #F23030;
      // // background: #F23030;
      // border-right: 500px solid #FF9900;
      background: #eff3f6;

      span {
        display: inline-block;
        height: 100%;
      }
    }
  }
}

.mlink {
    &.success {
        color: #52C41A;
    }

    &.danger {
        color: #F5222D;
    }

    &.warning {
        color: #FA8C16;
    }
}

.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 2px;

    &.danger {
        background-color: #F5222D;
    }

    &.warning {
        background-color: #FA8C16;
    }

    &.success {
        background-color: #52C41A;
    }
}
</style>